import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-admin-pre-order-edit",
  templateUrl: "./admin-pre-order-edit.component.html",
  styleUrls: ["./admin-pre-order-edit.component.css"],
})
export class AdminPreOrderEditComponent implements OnInit {
  preOrderForm: FormGroup;
  lastValidValue = ""; // To store the last valid numeric value

  constructor(
    private fb: FormBuilder,
    private matDialogRef: MatDialogRef<AdminPreOrderEditComponent>,
    private service: AdminService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.preOrderForm = this.fb.group({
      wo_price: ["", []],
      margin: ["", []],
      increase_timer: ["", []],
    });

    this.preOrderForm.patchValue({
      wo_price: this.formatToTwoDecimals(data.price_per_ton),
      margin: data.workorder_margin,
      increase_timer: 0,
    });
  }
  // Method to format a number to 2 decimal places
  formatToTwoDecimals(value: number): string {
    return value !== undefined && value !== null ? value.toFixed(2) : "0.00";
  }

  ngOnInit(): void {}

  // Method to restrict input to numbers and two decimal places in real-time
  limitDecimalPlaces(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;

    // Regular expression to allow numbers with up to two decimal places, no alphabetic characters
    const regex = /^\d*\.?\d{0,2}$/;

    // If the input matches the format, update last valid value
    if (regex.test(value)) {
      this.lastValidValue = value; // Update last valid value if input is valid
    } else {
      // Revert to the last valid value if input is invalid (contains letters or too many decimals)
      inputElement.value = this.lastValidValue;
      this.preOrderForm
        .get("price")
        ?.setValue(this.lastValidValue, { emitEvent: false });
    }
  }

  formatTime(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters

    input.value = value; // Update the input field
    this.preOrderForm.get("increase_timer")?.setValue(value, {
      emitEvent: false,
    });
  }

  close() {
    this.matDialogRef.close();
  }

  Update() {
    const data = {
      workorderid: this.data._id,
      margin: this.preOrderForm.value.margin,
      increase_timer: this.preOrderForm.value.increase_timer,
    };
    this.service.editWo(this.data.token, data).subscribe((res: any) => {
      this.matDialogRef.close({ success: "close" });

      this.snackBar.open(res.message, "Success", {
        duration: 3000,
      });
    });
  }
}
